import * as resourceService from '../services/resource';

export default function(input) {
    return resourceService.get(input);
}
